import { useInfiniteQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import type { AuditLog } from "@/types";

export interface AuditLogFilters {
  table?: string;
  action?: "INSERT" | "UPDATE" | "DELETE";
  limit?: number;
}

interface ListResponse {
  items: AuditLog[];
  nextCursor: string | null;
}

export function useAuditLogs(filters: AuditLogFilters = {}) {
  return useInfiniteQuery({
    queryKey: ["audit_logs", filters],
    initialPageParam: null as string | null,
    queryFn: async ({ pageParam }) => {
      const params: Record<string, string> = {};
      if (filters.table) params.table = filters.table;
      if (filters.action) params.action = filters.action;
      if (filters.limit) params.limit = String(filters.limit);
      if (pageParam) params.cursor = pageParam;
      const { data } = await apiClient.get<ListResponse>("/audit-logs", { params });
      return data;
    },
    getNextPageParam: (last) => last.nextCursor,
  });
}
